module.exports = __webpack_public_path__ + "static/H.BintangSoetjahjoMDPhD-f08e4b72f6102817326b498b8d39755c.jpg";